import { Box } from '@mui/material'
import { observer } from 'mobx-react-lite'
import { useUserStore } from 'src/feature/user/store/user.store'
import { SkillGapAnalysis } from '../component/template/SkillGapAnalysis'
import { useAuthStore } from 'src/feature/auth/store/auth.store'
import { OrganisationRole } from 'src/feature/control-panel/model/OrganisationRole'
import { TeamManagerQuickActions } from '../component/TeamManagerQuickActions'
import { UserQuickActions } from '../component/UserQuickActions'
import { GetStarted } from '../component/GetStarted'

export const UserDashboardPage = observer(() => {
  const userStore = useUserStore()
  const authStore = useAuthStore()

  const isSkillGap = (userStore.sitemap?.modules ?? []).some(s => s.key === 'skillGap')
  const isAdmin = [OrganisationRole.UserAdministrator, OrganisationRole.SystemAdministrator].some(role => authStore.hasRole(role))
  const isTeamManager = [OrganisationRole.UserAdministrator].some(role => authStore.hasRole(role))
  const isUser = authStore.hasRole(OrganisationRole.User) && !isAdmin

  return (
    <Box sx={styles.root}>
      <GetStarted />
      {isSkillGap && (
        <SkillGapAnalysis />
      )}
      {isTeamManager && <TeamManagerQuickActions />}
      {isUser && <UserQuickActions />}
    </Box>
  )
})

const styles = {
  root: {
    width: '100%',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
    padding: { xs: '1rem', md: '1rem 5rem' },
  },
}
